export default __webpack_public_path__ + "static/media/al-kindi.94216142.jpg";